module.exports = __webpack_public_path__ + "files/aa748f6ade990f6a5f5965cbdb0a4238.png";